import { Injectable } from '@angular/core';
import { IReport, ReportStatus, ResponsibleType } from '@shared/interfaces';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class ReportViewService {
    constructor(private translateService: TranslateService) {}

    _items: IReport[];

    getColumn(groupBy: string, item: IReport): IGroupValueReport {
        let label: string;
        let extra = '';
        let parentId;

        switch (groupBy) {
            case 'reportStatus':
                label = 'generic.filter.' + item.reportStatus;
                break;
            case 'year':
                label = new Date(item.dueDate).getFullYear().toString();
                break;
            case 'responsibility':
                label = 'generic.filter.' + item.responsible.responsibleType;

                parentId = item.responsible.orgLevel > 1 ? label : null;

                if (parentId) {
                    extra = `Level ${item.responsible.orgLevel}`;
                    label = `${extra}`;
                }

                break;
            default:
                label = 'generic.filter.all';
        }
        return label
            ? {
                  label,
                  extra,
                  id: `${label}`,
                  parentId,
                  responsibleType: item.responsible.responsibleType,
                  orgLevel: item.responsible.orgLevel ?? 1,
                  reportStatus: item.reportStatus
              }
            : null;
    }
}

export interface IGroupValueReport {
    id: string;
    label: string;
    extra?: string;
    parentId?: string;
    responsibleType?: ResponsibleType;
    orgLevel?: number;
    reportStatus?: ReportStatus;
}
